export default __webpack_public_path__ + "static/media/IFPRI.e0e85c5c.svg";